<app-link-with-popup
  [headerText]="'General.PopUp.FilterProfileDetails' | translate"
  [linkText]="linkText"
  [isLoading]="isLoading"
  (popupOpen)="onPopupOpen()"
>
  <div *ngIf="!isLoading">
    <app-filter-profile-display
      [filterProfile]="filterProfile"
      [filterModel]="filterModel"
    ></app-filter-profile-display>
  </div>
</app-link-with-popup>
